import { HStack, Spacer, Stack, Text } from '@chakra-ui/react'
import type { FC } from 'react'

import CommentsCount from '../commentsCount'

import CardConfidenceRating from '@app/next/domainObjects/confidenceRating/cardConfidenceRating'
import cardFontSize from '@app/shared/cards/cardFontSize'
import CardSection from '@app/shared/cards/components/cardSection'
import CardEntityContributorsAndStatus, {
  shouldRenderCardEntityContributorsAndStatus
} from '@app/shared/cards/entity/cardEntityContributorsAndStatus'
import CardEntityStatsAndProgress, {
  shouldRenderCardEntityStatsAndProgress
} from '@app/shared/cards/entity/cardEntityStatsAndProgress'
import CardEntityStatus from '@app/shared/cards/entity/cardEntityStatus'
import type { CardSize, DomainEntity } from '@app/types'

type Props = {
  entity: DomainEntity
  size?: CardSize
}

const CollapsedEntity: FC<Props> = ({ entity, size = 'normal' }) => {
  const { commentsCount, confidenceRating, name, foreignState, workflowState } = entity
  const fontSize = cardFontSize('md', size)

  return (
    <Stack gap={3}>
      <HStack>
        {confidenceRating && <CardConfidenceRating type={confidenceRating} />}
        <Text fontSize={fontSize} fontWeight="semibold">
          {name}
        </Text>
        <Spacer />
        <CommentsCount commentsCount={commentsCount} />
      </HStack>
      {shouldRenderCardEntityContributorsAndStatus(entity) && (
        <CardSection collapse>
          <CardEntityStatsAndProgress entity={entity} size={size} />
        </CardSection>
      )}
      {(shouldRenderCardEntityStatsAndProgress(entity) || foreignState) && (
        <CardSection collapse>
          <CardEntityContributorsAndStatus entity={entity} size={size}>
            <CardEntityStatus status={foreignState} workflowState={workflowState} size={size} />
          </CardEntityContributorsAndStatus>
        </CardSection>
      )}
    </Stack>
  )
}

export default CollapsedEntity
